/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _call_super = require("@swc/helpers/_/_call_super");
var _class_call_check = require("@swc/helpers/_/_class_call_check");
var _create_class = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var Hook = require("./Hook");
var HookCodeFactory = require("./HookCodeFactory");
var AsyncSeriesWaterfallHookCodeFactory = /*#__PURE__*/ function(HookCodeFactory) {
    _inherits._(AsyncSeriesWaterfallHookCodeFactory, HookCodeFactory);
    function AsyncSeriesWaterfallHookCodeFactory() {
        _class_call_check._(this, AsyncSeriesWaterfallHookCodeFactory);
        return _call_super._(this, AsyncSeriesWaterfallHookCodeFactory, arguments);
    }
    _create_class._(AsyncSeriesWaterfallHookCodeFactory, [
        {
            key: "content",
            value: function content(param) {
                var onError = param.onError, onResult = param.onResult, _onDone = param._onDone;
                return this.callTapsSeries({
                    onError: (i, err, next, doneBreak)=>onError(err) + doneBreak(true),
                    onResult: (i, result, next)=>{
                        var code = "";
                        code += `if(${result} !== undefined) {\n`;
                        code += `${this._args[0]} = ${result};\n`;
                        code += "}\n";
                        code += next();
                        return code;
                    },
                    onDone: ()=>onResult(this._args[0])
                });
            }
        }
    ]);
    return AsyncSeriesWaterfallHookCodeFactory;
}(HookCodeFactory);
var factory = new AsyncSeriesWaterfallHookCodeFactory();
function COMPILE(options) {
    factory.setup(this, options);
    return factory.create(options);
}
function AsyncSeriesWaterfallHook() {
    var args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
    if (args.length < 1) {
        throw new Error("Waterfall hooks must have at least one argument");
    }
    var hook = new Hook(args, name);
    hook.constructor = AsyncSeriesWaterfallHook;
    hook.compile = COMPILE;
    hook._call = undefined;
    hook.call = undefined;
    return hook;
}
AsyncSeriesWaterfallHook.prototype = null;
module.exports = AsyncSeriesWaterfallHook;
